import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import CustomSceditor from "../../components/sceditor/CustomSceditor";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { AlertService } from "../../utility/service/alert-service";
import { downloadMultipartFile } from "../../utility/service/api-file";
import { modifyCarbonFootprintReport } from "../../utility/service/carbonFootprint-service";
import { checkDpSuccess } from "../../utility/service/tool-service";

export default function InventoryCarbonFootprint_EditFile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sceditorRef = useRef(null);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);
  const { setAction, action, setItemObj, itemObj, companyName } = useOutletContext();
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isEditable = useEditableFlag("F10503"); // control edit by F10503

  const handleSubmitFile = (type) => {
    setIsLoading(true);
    let htmlContent = window.sceditor.instance(sceditorRef.current).getBody().innerHTML; //或是outerHTML
    htmlContent = htmlContent.replace(/<p[^>]*>\s*<\/p>/g, "");
    // console.log('Editor HTML content:', htmlContent);
    const blob = new Blob([htmlContent], { type: "text/html" });

    const formData = new FormData();
    formData.append("reportSeq", itemObj?.reportSeq);
    formData.append("type", type);
    formData.append("attachFile", blob, "sample.html");
    axios_modifyCarbonFootprintReport(formData);
  };

  const axios_modifyCarbonFootprintReport = (formData) => {
    modifyCarbonFootprintReport(formData)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
          navigate("/management/inventoryCarbonFootprint/report");
        }
      })
      .finally((fin) => {
        setIsLoading(false);
      });
  };

  const handleSceditorImportHTML = (html) => {
    const instance = window.sceditor.instance(sceditorRef.current);
    instance.insert(html, false);
  };

  // 確保獲取 sceditor 實例並且初始化完成
  function waitForSceditorReady(editorElement) {
    return new Promise((resolve) => {
      const instance = window.sceditor.instance(editorElement);
      if (instance) {
        resolve(instance);
      } else {
        // 如果實例還未準備好，監聽 ready 事件
        instance.on("ready", () => resolve(instance));
      }
    });
  }

  useEffect(() => {
    if (itemObj?.fileId !== undefined) {
      checkLoading(loading);
      downloadMultipartFile(
        {
          fileId: itemObj?.fileId,
        },
        "text"
      )
        .then(async (res) => {
          if (res?.status === 200) {
            if (res.data) {
              // 等待 sceditor 實例準備好
              await waitForSceditorReady(sceditorRef.current);
              // 現在 sceditor 實例已經準備好，可以調用 handleSunImportHTML
              handleSceditorImportHTML(res.data);
            } else {
              console.error("Unexpected data format:", res.data);
            }
          } else {
            AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    } else {
      console.log("error");
      navigate("/management/inventoryCarbonFootprint/report");
    }
  }, [itemObj]);

  return (
    <>
      {/* html 文字區塊 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              navigate("/management/inventoryCarbonFootprint/report");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
        <div className="align-items-end"></div>
      </div>

      <div className="p-card">
        <div className="p-card-body">
          {(itemObj?.companyName ?? companyName) && itemObj?.version && (
            <div className="flex justify-content-between flex-wrap align-items-center mb-2">
              <div className="align-items-start">
                <span className="font-bold">{itemObj?.companyName ?? companyName}</span>
              </div>
              <div className="align-items-end">
                <span className="font-bold">
                  {t("versionNo")}: {itemObj?.version}
                </span>
              </div>
            </div>
          )}
          {/* <SlateEditor value={value} setValue={setValue} /> */}
          {/* <QuillEditor content={content} setContent={setContent} quillRef={quillRef} /> */}
          {/* <CusSceditor id="editor" content={content}  /> */}
          <CustomSceditor sceditorRef={sceditorRef} value={content} disabled={!isEditable} />
          {/* <CusSunEditor content={content} setContent={setContent}  /> */}
        </div>
        <div className="col-12 gap-2 flex-all-center">
          <Button
            disabled={isLoading || !isEditable}
            loading={isLoading}
            type="button"
            label={t("button.save")}
            size="small"
            onClick={() => {
              handleSubmitFile("E");
            }}
          />
          {itemObj?.isConfirm ? (
            <></>
          ) : (
            <Button
              disabled={isLoading || !isEditable}
              loading={isLoading}
              type="button"
              label={t("button.release")}
              size="small"
              onClick={() => {
                handleSubmitFile("C");
              }}
            />
          )}

          <Button
            disabled={isLoading}
            outlined
            type="button"
            label={t("button.cancel")}
            size="small"
            onClick={() => {
              navigate("/management/inventoryCarbonFootprint/report");
            }}
          />
        </div>
      </div>
    </>
  );
}
